import React, { useEffect } from "react";
import { useLDClient, withLDProvider } from "launchdarkly-react-client-sdk";
import env from "../../utils/env";
import { setLDClient } from "./ldClient";

type LaunchDarklyProviderProps = React.PropsWithChildren;

const LaunchDarklyProvider: React.FC<LaunchDarklyProviderProps> = ({
  children,
}) => {
  const [isReady, setIsReady] = React.useState(false);
  const ldClient = useLDClient();

  useEffect(() => {
    setLDClient(ldClient);
    if (!ldClient) return;

    const handleReady = () => setIsReady(true);

    const handleError = (error: Error) => {
      console.warn("LaunchDarkly initialization error:", error);
    };

    ldClient.waitForInitialization().then(handleReady).catch(handleError);
  }, [ldClient]);

  if (!isReady) {
    return <></>;
  }

  return <>{children}</>;
};

const clientSideID = env.LAUNCHDARKLY_CLIENT_SIDE_ID;

const getUserContext = () => {
  try {
    const profileData = localStorage.getItem("profile");

    if (profileData) {
      const profile = JSON.parse(profileData);
      return {
        key: profile.email,
        email: profile.email,
      };
    }
  } catch (error) {
    console.warn("Failed to parse user profile for LaunchDarkly:", error);
  }

  return {
    key: "anonymous-user",
    name: "Anonymous User",
  };
};

const WrappedLaunchDarklyProvider = withLDProvider({
  clientSideID,
  user: getUserContext(),
  options: {
    bootstrap: "localStorage",
  },
})(LaunchDarklyProvider) as React.FC<React.PropsWithChildren>;

export default WrappedLaunchDarklyProvider;
